import { render, staticRenderFns } from "./scroll-button.vue?vue&type=template&id=590d1f94&lang=html&"
import script from "./scroll-button.vue?vue&type=script&lang=js&"
export * from "./scroll-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Devdoc\\_packages\\moss-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('590d1f94')) {
      api.createRecord('590d1f94', component.options)
    } else {
      api.reload('590d1f94', component.options)
    }
    module.hot.accept("./scroll-button.vue?vue&type=template&id=590d1f94&lang=html&", function () {
      api.rerender('590d1f94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/scroll-button.vue"
export default component.exports